module.exports = __webpack_public_path__ + "static/media/defaultAvatar12.b15ca057.svg";